/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_DashInputs */



/**
* | output |
* | --- |
* | "DASH Manifest" |
*
* @param {Media_Import_Source_DashInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_dash = /** @type {((inputs?: Media_Import_Source_DashInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_DashInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manifeste DASH")
	if (locale === "de") return /** @type {LocalizedString} */ ("DASH-Manifest")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manifesto DASH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Манифест DASH")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manifiesto DASH")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("DASH清单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("DASHマニフェスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("DASH मैनिफेस्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manifesto DASH")
	return /** @type {LocalizedString} */ ("DASH Manifest")
});